export default function useRotas(){
    return (route, params) => {
        if (params){
            return window.route(route, params)
        } else {
            return window.route(route)
        }
    };
}
